import { render } from "./Maldicion.vue?vue&type=template&id=7bf016c0"
import script from "./Maldicion.vue?vue&type=script&lang=js"
export * from "./Maldicion.vue?vue&type=script&lang=js"

import "./Maldicion.vue?vue&type=style&index=0&id=7bf016c0&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__